import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons';
import styles from './Reviews.module.scss';

interface RatingStarsInlineProps {
    value: number; // 0-5
    size?: number; // px
}

const RatingStarsInline: React.FC<RatingStarsInlineProps> = ({ value, size = 16 }) => {
    return (
        <span className={styles.rating}>
            {[1, 2, 3, 4, 5].map(n => {
                const active = n <= value;
                const icon = active ? faStarSolid : faStarRegular;
                return (
                    <FontAwesomeIcon
                        key={n}
                        icon={icon}
                        className={active ? styles.ratingStarActive : styles.ratingStar}
                        style={{ width: size, height: size }}
                    />
                );
            })}
        </span>
    );
};

export default RatingStarsInline;
